import { formatDateOnly } from "../../../../../_logic/dates"

export type AppointmentPlanningInputEventValue = Date | string | number | null

export type AppointmentPlanningInputEventReadResult =
  | { found: true; value: AppointmentPlanningInputEventValue }
  | { found: false }

const isRecord = (candidate: unknown): candidate is Record<string, unknown> =>
  candidate !== null && typeof candidate === "object" && !Array.isArray(candidate)

const isSupportedValue = (value: unknown): value is AppointmentPlanningInputEventValue =>
  value === null || value instanceof Date || typeof value === "string" || typeof value === "number"

export const readAppointmentPlanningInputEventValue = (
  event: Event,
): AppointmentPlanningInputEventReadResult => {
  const detail = (event as CustomEvent<{ value?: unknown }>).detail

  if (isRecord(detail) && "value" in detail) {
    return isSupportedValue(detail.value) ? { found: true, value: detail.value } : { found: false }
  }

  const target = event.target as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null

  if (target && "value" in target) return { found: true, value: target.value ?? "" }

  return { found: false }
}

export const dateTimeFromAppointmentPlanningInputValue = (
  value: AppointmentPlanningInputEventValue,
): Date | null | undefined => {
  if (value === null || value === "") return null

  const parsed = value instanceof Date ? value : new Date(value)

  return Number.isFinite(parsed.getTime()) ? parsed : undefined
}

export const dateOnlyFromAppointmentPlanningInputValue = (
  value: AppointmentPlanningInputEventValue,
): string | null | undefined => {
  if (value === null || value === "") return null

  const normalized = formatDateOnly(value)

  return normalized || undefined
}
